export default "__VITE_ASSET__f4200bda__"